import { render, staticRenderFns } from "./projectControl.vue?vue&type=template&id=c1419dc6&scoped=true"
import script from "./projectControl.vue?vue&type=script&lang=js"
export * from "./projectControl.vue?vue&type=script&lang=js"
import style0 from "./projectControl.vue?vue&type=style&index=0&id=c1419dc6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1419dc6",
  null
  
)

export default component.exports